import { Pipe, PipeTransform } from '@angular/core';
import { AttachmentFileType } from '@view-models/enums/attachment-file-type.enum';

@Pipe({
  name: 'fileExt'
})
export class FileExtPipe implements PipeTransform {
  static getFileExtension(fileName: string): string {
    if (fileName) {
      const index = fileName.lastIndexOf('.');
      return index >= 0 ? fileName.substr(index + 1) : '';
    }
    return fileName;
  }

  // tslint:disable-next-line: no-any
  transform(value: string, args?: any): any {
    return FileExtPipe.getFileExtension(value);
  }
}
